/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_DesktopInputs */



/**
* | output |
* | --- |
* | "Desktop Application (Windows, Mac, and Linux)" |
*
* @param {Signup_Compare_DesktopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_desktop = /** @type {((inputs?: Signup_Compare_DesktopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_DesktopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
	return /** @type {LocalizedString} */ ("Desktop Application (Windows, Mac, and Linux)")
});